import React, { useEffect, useState } from 'react';
import LogoImg from '../assets/BWE_logo.webp'
import LogoWhiteImg from '../assets/bwe-white-logo.png'
import { FaFacebookF, FaLinkedinIn } from "react-icons/fa";
import { CgMenuRightAlt, CgClose } from "react-icons/cg";
import { RiWhatsappFill } from "react-icons/ri";
import {
  FaHome,
  FaInfoCircle,
  FaBoxOpen,
  FaRobot,
  FaRupeeSign,
  FaCode,
  FaImages,
  FaEnvelope,
  FaChevronRight,
  FaHeadset
} from "react-icons/fa";
import {
  FiClock,
  FiMapPin,
  FiMail,
  FiPhone,
} from "react-icons/fi";

const Sidebar = ({isScrolled}) => {
  const [activeSection, setActiveSection] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState("home");
  const toggleMenu = () => setMenuOpen(!menuOpen);

  useEffect(() => {
    const sections = document.querySelectorAll("section");

    const observer = new IntersectionObserver(
      (entries) => {
        const visibleEntries = entries.filter((entry) => entry.isIntersecting);

        if (!visibleEntries.length) return;

        const bestEntry = visibleEntries.reduce((prev, curr) =>
          curr.intersectionRatio > prev.intersectionRatio ? curr : prev
        );

        setActiveSection(bestEntry.target.id);
        setActiveMenu(bestEntry.target.id);
      },
      {
        threshold: [0.1, 0.25, 0.5],
        rootMargin: "-35% 0px -35% 0px",
      }
    );

    sections.forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, []);

  return (
    <div className='nav-dash-bar-menus'>
      <div className="mobile-menu">
        <div className={`mobileHeader ${isScrolled ? "mobileHeader--scrolled" : ""}`}>
          <div className="mobileHeader__container">
            <div className="mobileHeader__logo">
              <img src={LogoWhiteImg} alt="logo" />
            </div>
            <button className="mobileHeader__menu" onClick={toggleMenu}>
              {menuOpen ? <CgClose className='close-menu-icon' /> : <CgMenuRightAlt className='mbl-menu-icon' />}
            </button>
          </div>
          <span className="mobileHeader__bottomGlow"></span>
        </div>

        <div className={`mobile-menu-dropdown ${menuOpen ? "open" : ""}`}>

          <ul>

            <li className={activeMenu === "home" ? "active" : ""}>
              <a href="#home" onClick={() => { setActiveMenu("home"); setMenuOpen(false) }}>
                <span className="menu-icon orange">
                  <FaHome />
                </span>

                <span>Home</span>

                <FaChevronRight className="arrow" />
              </a>
            </li>

            <li className={activeMenu === "about" ? "active" : ""}>
              <a href="#about" onClick={() => { setActiveMenu("about"); setMenuOpen(false) }}>
                <span className="menu-icon cyan">
                  <FaInfoCircle />
                </span>

                <span>About Us</span>

                <FaChevronRight className="arrow" />
              </a>
            </li>

            <li className={activeMenu === "productsAndServices" ? "active" : ""}>
              <a href="#productsAndServices" onClick={() => { setActiveMenu("productsAndServices"); setMenuOpen(false) }}>
                <span className="menu-icon blue">
                  <FaBoxOpen />
                </span>

                <span>Products & Services</span>

                <FaChevronRight className="arrow" />
              </a>
            </li>

            <li className={activeMenu === "ai" ? "active" : ""}>
              <a href="#ai" onClick={() => { setActiveMenu("ai"); setMenuOpen(false) }}>
                <span className="menu-icon purple">
                  <FaRobot />
                </span>

                <span>Artificial Intelligence</span>

                <FaChevronRight className="arrow" />
              </a>
            </li>

            <li className={activeMenu === "pricing" ? "active" : ""}>
              <a href="#pricing" onClick={() => { setActiveMenu("pricing"); setMenuOpen(false) }}>
                <span className="menu-icon green">
                  <FaRupeeSign />
                </span>

                <span>Pricing</span>

                <FaChevronRight className="arrow" />
              </a>
            </li>

            <li className={activeMenu === "lowcode" ? "active" : ""}>
              <a href="#lowcode" onClick={() => { setActiveMenu("lowcode"); setMenuOpen(false) }}>
                <span className="menu-icon yellow">
                  <FaCode />
                </span>

                <span>Low Code</span>

                <FaChevronRight className="arrow" />
              </a>
            </li>

            <li className={activeMenu === "productScreenshots" ? "active" : ""}>
              <a href="#productScreenshots" onClick={() => { setActiveMenu("productScreenshots"); setMenuOpen(false) }}>
                <span className="menu-icon sky">
                  <FaImages />
                </span>

                <span>Product Screenshots</span>

                <FaChevronRight className="arrow" />
              </a>
            </li>

            <li className={activeMenu === "contact" ? "active" : ""}>
              <a href="#contact" onClick={() => { setActiveMenu("contact"); setMenuOpen(false) }}>
                <span className="menu-icon red">
                  <FaEnvelope />
                </span>

                <span>Contact & Support</span>

                <FaChevronRight className="arrow" />
              </a>
            </li>

          </ul>

          <div className="menu-support-card">

            <div className="support-icon">
              <FaHeadset />
            </div>

            <div>

              <h5>Need Assistance?</h5>

              <p>We're here to help you.</p>

              <a href="#contact" onClick={() => setMenuOpen(false)}>
                Get in touch →
              </a>

            </div>

          </div>
          <div className='mbl-social-icon'>
            <p className="follow-text">Follow us.</p>

            <ul className="socials">
              <li>
                <a
                  className="social-icon facebook"
                  href="https://www.facebook.com/profile.php?id=61590763205839"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaFacebookF />
                </a>
              </li>

              <li>
                <a
                  className="social-icon linkedin"
                  href="https://www.linkedin.com/company/132333928/admin/dashboard/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaLinkedinIn />
                </a>
              </li>

              <li>
                <a
                  className="social-icon whatsapp"
                  href="https://wa.me/916383830073"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <RiWhatsappFill />
                </a>
              </li>
            </ul>
          </div>
        </div>

      </div>
      <aside className="dash-nav-sidebar custom-scrollbar">
        <div className="sidebar">
          <header>
            <div className="bwe-contact-card">
              <div className="bwe-card-glow"></div>
              <div className="bwe-logo-area">
                <img src={LogoImg} alt="Logo" />
              </div>
              <span className="bwe-divider">
                <span></span>
              </span>

              <div className="bwe-info-list">

                <div className="bwe-info-item">
                  <div className="bwe-icon-box">
                    <FiClock />
                  </div>

                  <div className="bwe-info-content">
                    <h4>Operating Hours</h4>
                    <p>10:00 am to 6:00 pm,</p>
                    <p>Monday through Saturday</p>
                  </div>
                </div>

                <div className="bwe-info-item">
                  <div className="bwe-icon-box">
                    <FiMapPin />
                  </div>

                  <div className="bwe-info-content">
                    <h4>Address</h4>
                    <p>
                      14 A, 4th Floor, Ramakrishna Nagar,<br />
                      New Siddhapudur, Coimbatore,<br />
                      Tamil Nadu, Pin : 641044.
                    </p>
                  </div>
                </div>

                <div className="bwe-info-item">
                  <div className="bwe-icon-box">
                    <FiMail />
                  </div>

                  <div className="bwe-info-content">
                    <h4>Email</h4>
                    <p><a href='mailto:contact@bwefinserv.com' target='_blank' rel="noreferrer">contact@bwefinserv.com</a></p>
                  </div>
                </div>

                <div className="bwe-info-item">
                  <div className="bwe-icon-box">
                    <FiPhone />
                  </div>

                  <div className="bwe-info-content">
                    <h4>Phone</h4>
                    <p><a href='tel:6383830073' target='_blank' rel="noreferrer">63838 30073</a></p>
                  </div>
                </div>
              </div>

              <span className="bwe-divider">
                <span></span>
              </span>

            </div>
          </header>
          <nav className="sidebar-nav-link">
            <ul>
              <li>
                <a href="#home" className={activeSection === 'home' ? 'active' : ''}>
                  <span className={`nav-line ${activeSection === 'home' ? 'active' : ''}`}></span> Home
                </a>
              </li>
              <li>
                <a href="#about" className={activeSection === 'about' ? 'active' : ''}>
                  <span className={`nav-line ${activeSection === 'about' ? 'active' : ''}`}></span> About Us
                </a>
              </li>
              <li>
                <a href="#productsAndServices" className={activeSection === 'productsAndServices' ? 'active' : ''}>
                  <span className={`nav-line ${activeSection === 'productsAndServices' ? 'active' : ''}`}></span> Products & Services
                </a>
              </li>
              <li>
                <a href="#ai" className={activeSection === 'ai' ? 'active' : ''}>
                  <span className={`nav-line ${activeSection === 'ai' ? 'active' : ''}`}></span> Artificial Intelligence
                </a>
              </li>
              <li>
                <a href="#pricing" className={activeSection === 'pricing' ? 'active' : ''}>
                  <span className={`nav-line ${activeSection === 'pricing' ? 'active' : ''}`}></span> Pricing
                </a>
              </li>
              <li>
                <a href="#lowcode" className={activeSection === 'lowcode' ? 'active' : ''}>
                  <span className={`nav-line ${activeSection === 'lowcode' ? 'active' : ''}`}></span> Low Code
                </a>
              </li>
              <li>
                <a href="#productScreenshots" className={activeSection === 'productScreenshots' ? 'active' : ''}>
                  <span className={`nav-line ${activeSection === 'productScreenshots' ? 'active' : ''}`}></span> Product Screenshots
                </a>
              </li>
              <li>
                <a href="#contact" className={activeSection === 'contact' ? 'active' : ''}>
                  <span className={`nav-line ${activeSection === 'contact' ? 'active' : ''}`}></span> Contact & Support
                </a>
              </li>
            </ul>
          </nav>
          <footer>
            <p className="follow-text">Follow us.</p>

            <ul className="socials">
              <li>
                <a
                  className="social-icon facebook"
                  href="https://www.facebook.com/profile.php?id=61590763205839"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaFacebookF />
                </a>
              </li>

              <li>
                <a
                  className="social-icon linkedin"
                  href="https://www.linkedin.com/company/132333928/admin/dashboard/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaLinkedinIn />
                </a>
              </li>

              <li>
                <a
                  className="social-icon whatsapp"
                  href="https://wa.me/916383830073"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <RiWhatsappFill />
                </a>
              </li>
            </ul>
          </footer>
        </div>
      </aside>
    </div>
  );
};

export default Sidebar;